import { InjectionToken } from '@angular/core';

import { AsamcoAuthService } from '../auth/asamco-auth.service';
import { getServerSettingForRequest } from './get-server-setting-for-request';
import { HttpRequest } from '@angular/common/http';

export const BASE_API_ADDRESS_PROVIDER: InjectionToken<IBaseApiAddressProvider> = new InjectionToken('BASE_API_ADDRESS_PROVIDER');

export interface IBaseApiAddressProvider {
	getBaseUrl(request: HttpRequest<any>);
}

export class AuthenticatedUserBaseApiAddressProvider implements IBaseApiAddressProvider {
	constructor(private authService: AsamcoAuthService) {}

	getBaseUrl(request: HttpRequest<any>) {
		const backendInfo = getServerSettingForRequest(this.authService, request);
		return backendInfo?.baseUrl;
	}
}

export class DefaultBaseApiAddressProvider implements IBaseApiAddressProvider {
	private baseUrl: string;

	setBaseUrl(baseUrl: string) {
		this.baseUrl = baseUrl;
	}

	getBaseUrl(request: HttpRequest<any>) {
		return this.baseUrl;
	}
}
